<template>
    <local-tree-view ref="treeRef" :data-source="items" 
        :meta="meta" 
        @item-click="onItemClick">
        <template #item-template="{ data }">
            <div class="flex items-center gap-2">
                <img :src="`/infoenergo/assets/${data.type === 'd' ? 'department' : 'person'}.svg`" />
                {{ data.name }}
            </div>
        </template>
    </local-tree-view>
</template>

<script setup>
import { ref, defineEmits, onMounted } from 'vue';

import LocalTreeView from '@/components/local-tree-view.vue';
import { api } from '@/service/http';

const treeRef = ref();
const treeInstance = ref();
const items = ref([]);
const selectedItem = ref(null);

defineProps({
    dataSource: {
        type: Array,
        default: () => [],
    },
    meta: {
        type: Object,
        default: () => {
            return {
                searchHint: null,
                valueChangeEvent: 'keyup',

                keyExpr: 'key',
                displayExpr: 'name',
                parentIdExpr: 'parent_id',
                autoExpandAll: true,
                rootValue: null,
                dataStructure: 'plain',
                selectByClick: true,
                expandEvent: 'dblclick',
                selectionMode: 'single',
                itemTemplate: 'item-template',
            };
        },
    },
});

const emit = defineEmits(['WhoChangeActive']);

onMounted(async () => {
    await initData();
    treeInstance.value = treeRef.value.treeViewInstance;
});

const initData = async () => {
    try {
        const response = await api('admin./department/official/list/get', { kod_ecls: 1 });
        //todo форматы ответа везде (в других функциях) сделать как тут
        items.value = response.items;
    } catch (error) {
        items.value = [];
        return {
            result: false,
            error: error.message,
            uuid: '1f98743e-4194-480e-b881-9c8c71403aec',
        };
    }
};

const selectNode = key => {
    if(key){
        treeInstance.value.expandItem(key);
        treeInstance.value.selectItem(key);
    }
}

const onItemClick = event => {
    emit('WhoChangeActive', event.itemData);
    selectedItem.value = event.itemData;
};

defineExpose({
    treeInstance,
    data: items,
    selectedItem,
    selectNode,
});
</script>
